import { render } from "./IMatchEventsSkeleton.vue?vue&type=template&id=75fed16d&scoped=true"
const script = {}

import "./IMatchEventsSkeleton.vue?vue&type=style&index=0&id=75fed16d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75fed16d"]])

export default __exports__